// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"bd0e0007","79":"36475c8a","319":"c49618eb","433":"9e4db4f3","438":"43968349","979":"2a18294a","991":"56d7d91a"}[chunkId] + ".chunk.js";
};